import React, { Fragment } from "react";
import SplashScreenForm from "./SplashScreenForm";
import OnBoardingForm from "./OnBoardingForm";
import { useDispatch, useSelector } from "react-redux";
import {
  removeImageFromPath,
  uploadFileToServer,
} from "../../../components/Forms/FormHandler.jsx";
import { toast } from "react-toastify";
import { SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";

const ConfigOnBoardingUi = () => {
  const data = useSelector((state) => state.systemconfig);
  const dispatch = useDispatch();
  let initialValues = {
    splash_screen: { image: "", title: "", subtitle: "" },
    onboarding_screen: [],
  };
  // console.log('svnisoevnsev', data)
  if (data) {
    initialValues = {
      ...data,
    };
  }
  const handleFormSubmit = async (values, { setSubmitting }, ...rest) => {
    try {
      setSubmitting(true);
      if (rest && rest[0] == "splash") {
        if (values.splash_screen?.image instanceof File) {
          const file = values.splash_screen?.image;
          try {
            // 🔍 upload file
            const url = await uploadFileToServer(file);
            // console.log('svnioevs', url);
            values.splash_screen.image = url;
          } catch (err) {
            toast.error("Error uploading file");
            console.error(err);
            return; // stop submit
          }
        } else if (
          values.splash_screen?.image == "" &&
          initialValues.splash_screen?.image != ""
        ) {
          await removeImageFromPath(initialValues.splash_screen?.image);
        }
        values.onboarding_screen = data.onboarding_screen;
      }
      if (rest && rest[0] == "onboarding") {
        for (let i = 0; i < values.onboarding_screen.length; i++) {
          if (values.onboarding_screen[i]?.image instanceof File) {
            const file = values.onboarding_screen[i]?.image;
            try {
              // 🔍 upload file
              const url = await uploadFileToServer(file);
              // console.log('svnioevs', url);
              values.onboarding_screen[i].image = url;
            } catch (err) {
              toast.error("Error uploading file");
              console.error(err);
              return; // stop submit
            }
          } else if (
            values.onboarding_screen[i]?.image == "" &&
            initialValues.onboarding_screen[i]?.image != ""
          ) {
            await removeImageFromPath(
              initialValues.onboarding_screen[i]?.image
            );
          }
        }
        values.splash_screen = data.splash_screen;
      }
      let method = "post";
      let endpoint = `configs`;
      // console.log("snvuisbevsevsdvs");
      if (values?._id) {
        method = "put";
        endpoint = `configs/${values?._id}`;
      }
      const response = await apiCaller({ method, data: values, url: endpoint })
        .then((response) => {
          //   dispatch(confirmedUpdatePostAction(post));
          // history.push(backUrl);
          // console.log('snvioesev', response);
          return response;
        })
        .catch((error) => {
          console.log("anvuoinsevsev", error);
          throw error;
        });
      localStorage.setItem(
        "systemconfigs",
        JSON.stringify(response?.data?.data)
      );
      dispatch({ type: SET_SYSTEM_CONFIG, payload: response?.data?.data });
      setSubmitting(false);
    } catch (error) {}
  };
  return (
    <Fragment>
      <div className="row container-mxw">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">Splash Screen</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <SplashScreenForm
                  initialValues={initialValues}
                  handleFormSubmit={handleFormSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row container-mxw">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">On Boarding Screen</h4>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <OnBoardingForm
                  initialValues={initialValues}
                  handleFormSubmit={handleFormSubmit}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ConfigOnBoardingUi;
